const customerFreelancerLinkEn = {
    customerFreelancerLink: require('../../lang/en/customer_freelancer_link/CustomerFreelancerLink').default,
};

export default customerFreelancerLinkEn;
